import { Component, OnInit } from '@angular/core';
//import { ConfigurationService } from './../configuration.service';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.css'],
  providers: []
})
export class RedirectComponent implements OnInit {

  constructor() { }

  ngOnInit() {

    window.location.href = 'http://loyaltyclub.pl';
  }

}
